import { render, staticRenderFns } from "./SectionC.vue?vue&type=template&id=5cfd30a4&scoped=true"
import script from "./SectionC.vue?vue&type=script&lang=js"
export * from "./SectionC.vue?vue&type=script&lang=js"
import style0 from "./SectionC.vue?vue&type=style&index=0&id=5cfd30a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd30a4",
  null
  
)

export default component.exports